import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  ReplacementOffer,
  UpfrontPaymentSummary,
} from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-upfront-payment-summary',
  templateUrl: './upfront-payment-summary.component.html',
  styleUrls: ['./upfront-payment-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpfrontPaymentSummaryComponent {
  @Input() data: UpfrontPaymentSummary;
  @Input() selected: ReplacementOffer;
  @Input() isDirectDebitSummaryShown = true;
  @Input() showTotal = false;
}
